// extracted by mini-css-extract-plugin
export default {"currency-conversion-confirmation-modal":"components-settings-currency-conversion-modals-delete-profile-module__currency-conversion-confirmation-modal"};